/**
 * @Author: zpc
 * @Description:
 * @DateTime: Created in 2022-03-17
 */

import Api from 'src/util/api';
import { PageDo, Result, ResultPageDo, Integer } from 'src/types/base';
import EnumItem from 'src/enums/enumItem';

export declare namespace SnConfigDOI {
    export interface RowDataI {
        id: number
        sn: string
        sn_status: number
        user_name: string
        user_phone: string
        register_time: string
    }

    export interface QueryRowDataParamsI extends PageDo {
        sn?: string;
        user_name?: string;
    }

    export interface OperateParamsI {
        id?: Integer
        user_name: string
        user_phone: string
    }

    export interface RowDataIs {
        id?:Integer
        sn:string
        file_name:string
        time:string
    }
}

export default class SnConfigApi {
    /**
     * 查询sn号信息列表
     */
    static async searchList(params: SnConfigDOI.QueryRowDataParamsI): Promise<ResultPageDo<SnConfigDOI.RowDataI[]>> {
        return Api.post('/monitor/query/sn/info', {
            sn:"",
            user_name:"",
            ...params
        });
    }

    /**
     * 修改sn信息
     * @param data
     */
    static async update(data: SnConfigDOI.OperateParamsI): Promise<Result<any>> {
        return Api.post('/monitor/edit/sn/info', data);
    }
    
    /**
     * 删除sn信息
     * @param sn_id 
     */
    static async delete(id: number ): Promise<Result<any>> {
        return Api.post('/monitor/delete/sn/info', {id});
    }

    /**
     * 激活sn
     * @param id
     */
    static async onSn(id: number ): Promise<Result<any>> {
        return Api.post('/monitor/on/sn/info', {id});
    }


    /**
     * 禁用sn
     * @param id
     */
     static async offSn(id: number ): Promise<Result<any>> {
        return Api.post('/monitor/off/sn/info', {id});
    }


    /**
     * 激活uuid
     * @param id
     */
    static async uuidOnSn(id: number ): Promise<Result<any>> {
        return Api.post('/monitor/on/uuid/info', {id});
    }


    /**
     * 禁用uuid
     * @param id
     */
    static async uuidOffSn(id: number ): Promise<Result<any>> {
        return Api.post('/monitor/off/uuid/info', {id});
    }

    
    /**
     * 查询操作日志
     * @param params 
     */
    static async searchLog(params: SnConfigDOI.QueryRowDataParamsI):Promise<ResultPageDo<SnConfigDOI.RowDataIs[]>> {
		return Api.post('/monitor/select/operation_log', {
            ...params
        })
    }
     
    /**
     * sn号添加文件权限
     * @param sn 
     * @param file_ids 
     */
    static async saveSnFile(sn: String,file_ids:number[]):Promise<Result<any>> {
		return Api.post('/monitor/sn/file/add', {sn,file_ids})
    }
     
    /**
     * 根据sn号查找文件id
     * @param sn 
     */
    static async querySnByFile(sn: String):Promise<Result<{file_id: number,sn: string}[]>> {
		return Api.post('/monitor/sn/by/file', {sn})
    }
}
